class RecoverPassword {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  notify(email) {
    return this.apiClient.post(`v1/users/recover-password/notify`, {
      email
    }, {
      ...this.apiClient.withRequestContext()
    }).then(response => response.data);
  }
  get(hash) {
    return this.apiClient.get(`v1/users/recover-password/${hash}`, {
      ...this.apiClient.withRequestContext()
    }).then(response => response.data);
  }
  create(hash, password, passwordConfirm) {
    return this.apiClient.post(`v1/users/recover-password/${hash}`, {
      password,
      password_confirm: passwordConfirm
    }, {
      ...this.apiClient.withRequestContext()
    }).then(response => response.data);
  }
}

export { RecoverPassword };
//# sourceMappingURL=RecoverPassword.js.map
